import React from 'react';
import { Routes, Route, BrowserRouter, useLocation, Navigate } from "react-router-dom"
import { connect } from "react-redux"
import Visitors from './pages/VisitsPage/Visits'
import PreRegisters from './pages/PreRegistersPage/PreRegisters'
import NotFound from './pages/NotFoundPage/NotFound'
import Login from './pages/LoginPage/Login'
import Broken from './pages/BrokenPage/Broken'
import Settings from './pages/SettingsPage/Settings'
import OfflineAudit from './pages/OfflineAuditPage/OfflineAudit'

import Logout from './pages/LogoutPage/Logout'
import LoadPage from './pages/LoadPage/LoadPage'
import { clearAuth } from './api/api';
import GuestOnly from './routing/GuestOnly'

function Auth({ children, profile }) {
  let location = useLocation()
  if (!profile.email) {
    clearAuth()
    return <Navigate to="/login" state={{ from: location }} />
  }
  return children
}

const mapStateToProps = state => {
  return { profile: state.profile }
}

const RequireAuth = connect(mapStateToProps)(Auth)
const RedirectIfAuthenticated = connect(mapStateToProps)(GuestOnly)

function RoutingSystem() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/load" element={<RequireAuth><LoadPage /></RequireAuth>} />
        <Route path="/login" element={<RedirectIfAuthenticated><Login /></RedirectIfAuthenticated>} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/" element={<RequireAuth><Visitors /></RequireAuth>} />
        <Route path="/settings" element={<RequireAuth><Settings /></RequireAuth>} />
        <Route path="/pre-registration" element={<RequireAuth><PreRegisters /></RequireAuth>} />
        {/* Ruta técnica para ingeniería — sin enlace en Menu/Header, acceso solo por URL directa */}
        <Route path="/system/offline-audit" element={<RequireAuth><OfflineAudit /></RequireAuth>} />
        <Route path="/broken" element={<Broken />} />
        <Route path='*' exact={true} element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default RoutingSystem
